var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var CloseThin = function CloseThin(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '-2.4 21.6 9.7 9.7' }, props),
    React.createElement(
      'g',
      null,
      React.createElement(
        'title',
        null,
        'close'
      ),
      React.createElement('path', { d: 'M7.3 22.4l-.7-.8-4.1 4.2-4.1-4.2-.8.8 4.2 4.1-4.2 4.1.8.7 4.1-4.1 4.1 4.1.7-.7-4.1-4.1z', className: 'st0' })
    )
  );
};
/*eslint-enable */

export default CloseThin;
//# sourceMappingURL=CloseThin.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/CloseThin.js